import React from 'react';

import { FiltersHeader } from '@vlabs/shared/components/filters-panel/FiltersHeader';
import { Group } from '@vlabs/uikit';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import { EventInfoSettingsPopover, EventSampleSettingsPopover } from './popovers';
import st from './WorkspaceSettingsPanel.module.sass';

interface WorkspaceSettingsPanelProps {
  className?: string;
  onCloseClick: VoidFunction;
}

function WorkspaceSettingsPanel({
  onCloseClick,
  className = undefined,
}: WorkspaceSettingsPanelProps): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <div className={cn(st.Root, className)}>

      <Group
        gapSize="0"
        vertical
      >
        <FiltersHeader
          customTitle={t('lunapoint:settings.event_feed_settings')}
          onClick={onCloseClick}
        />

        <EventInfoSettingsPopover />
        <div className={st.Divider} />

        <EventSampleSettingsPopover />
        <div className={st.Divider} />
      </Group>

    </div>
  );
}

export default WorkspaceSettingsPanel;
